import React from "react";
import {
  Checkbox,
  ListItem,
  ListItemText,
  withStyles
} from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { Classes, ThemeType } from "@theme";
import Body from "@components/typography/Body";

export type FilterSectionListItem = {
  key: string;
  name: React.ReactNode;
  selected: boolean;
  onToggle: () => void;
};

type Props = {
  classes: Classes<typeof styles>;
  items: FilterSectionListItem[];
};

class FilterSectionList extends React.Component<Props> {
  render() {
    const { classes, items } = this.props;

    return (
      <div className={classes.root}>
        {items.any() === false && (
          <div className={classes.notFound}>
            <Body>{locale.Empty}</Body>
          </div>
        )}

        {items.map(({ name, key, onToggle, selected }) => {
          const _name = typeof name === "string" ? <ListItemText primary={name} /> : name;

          return (
            <ListItem className={classes.item} dense button key={key} onClick={onToggle}>
              <Checkbox checked={selected} tabIndex={-1} disableRipple />
              {_name}
            </ListItem>
          );
        })}
      </div>
    );
  }
}

const styles = (theme: ThemeType) => ({
  root: {
    alignItems: "flex-start",
    display: "flex",
    flexFlow: "row wrap",
    // justifyContent: "space-between",
    minHeight: 96,
    maxHeight: 256,
    overflow: "scroll",
    paddingTop: 14
  },

  item: {
    padding: 0,
    flexBasis: "100%",

    [theme.breakpoints.down("sm")]: {
      flexBasis: "50%"
    },

    [theme.breakpoints.up("sm")]: {
      flexBasis: "33.33333%"
    },

    [theme.breakpoints.up("lg")]: {
      flexBasis: "25%"
    }
  },

  notFound: {
    alignSelf: "center",
    textAlign: "center",
    fontStyle: "italic",
    width: "100%"
  }
});

export default withStyles(styles as any)(FilterSectionList);
